module.exports = __webpack_public_path__ + "img/Sorting.0caa1ebc.svg";